import { type RouteRecordRaw } from "vue-router";

import { APP_SIGNDOCUMENTS_ROUTES as SIGNS } from "@/Generated/Routes/paths";

import { buildBeforeEnterChain, onlyPatientGuard } from "../guards";

export default [
  {
    path: SIGNS.root.path,
    components: {
      main: () => import("@/Components/layout/BlankLayout.vue"),
    },
    beforeEnter: buildBeforeEnterChain([onlyPatientGuard]),
    meta: {
      sidebar: false,
    },
    children: [
      {
        ...SIGNS.root,
        component: () => import("@/Views/documents/signs/index.vue"),
      },
      {
        ...SIGNS.view.root,
        component: () => import("@/Views/documents/signs/View/index.vue"),
      },
    ],
  },
] as RouteRecordRaw[];
